module.exports = __webpack_public_path__ + "img/williams.fb367b9b.jpg";